module.exports = __webpack_public_path__ + "static/media/mmFront2.eef3dbf5.jpg";